import React, { useEffect, useState } from "react";
import './RA_datasection.css';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';

const backendUrl = process.env.REACT_APP_BACKEND_API_URL_LOCAL;

const RAdatasection = () => {

    const navigate = useNavigate();
      const handleviewmoreclick = () => {
        navigate('/Roadaccident/Dashboard/BlackSpotData');
      };
      const handlereportroadcondition = () => {
        navigate('/Roadaccident/Dashboard/ReportRoadConditionData');
      };

    const [summary, setSummary] = useState(null);

    useEffect(() => {
      fetch(`${backendUrl}roadaccident/dashboard_summary/`)
        .then((response) => response.json())
        .then((data) => setSummary(data))
        .catch((error) => console.error("Error loading dashboard summary:", error));
    }, []);

    const formatNumber = (value) =>
      typeof value === "number" ? value.toLocaleString() : "—";

  return (
    <div>
      <div className="main-container">
                <div className="heading">
                    <h1>Accident Statistics</h1>
                </div>
                <div className="card-container">
                    <div className="card">
                        <h3 className="card-subheading">No. of Accidents</h3>
                        <h2 className="card-number">{formatNumber(summary?.accidents_count)}</h2>
                    </div>
                    <div className="card">
                        <h3 className="card-subheading">No. of Injured</h3>
                        <h2 className="card-number">{formatNumber(summary?.injured_count)}</h2>
                    </div>
                    <div className="card">
                        <h3 className="card-subheading">No. of Fatalities</h3>
                        <h2 className="card-number">{formatNumber(summary?.fatalities_count)}</h2>
                    </div>
                    <div className="card">
                        <h3 className="card-subheading">No. of Black Spot</h3>
                        <h2 className="card-number">{formatNumber(summary?.blackspot_count)}</h2>
                        <button className="view-more-btn" onClick={handleviewmoreclick}>
                            View data <FaArrowRight />
                        </button>
                    </div>
                    <div className="card">
                        <h3 className="card-subheading">Reports on Road Condition</h3>
                        <h2 className="card-number">{formatNumber(summary?.road_condition_count)}</h2>
                        <button className="view-more-btn" onClick={handlereportroadcondition}>
                            View data <FaArrowRight />
                        </button>
                    </div>
                </div>
            </div>
    </div>
  );
};

export default RAdatasection;
